"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignProductList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsTransfer_1 = require("../../model/hsTransfer");
var service_1 = require("../../../library/base/service");
var AssignProductList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AssignProductList, _super);
    function AssignProductList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '受让产品列表接口';
        _this.code = '105014';
        _this.desc = '受让产品列表接口';
        _this.requestParams = new hsTransfer_1.AssignProductListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return AssignProductList;
}(service_1.BaseService));
exports.AssignProductList = AssignProductList;
//# sourceMappingURL=assignProductList.js.map